// extracted by mini-css-extract-plugin
module.exports = {"drawerCollapsed":"style_drawerCollapsed__13O4a","drawerExpanded":"style_drawerExpanded__1Am3s"};